export default function Footer() {
  return (
    <footer className="app-footer">
      <address>© VisionFlow Group. All rights reserved.</address>
    </footer>
  );
}
